import { graphql, Link } from "gatsby"
import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/home.module.css'
import { GatsbyImage } from "gatsby-plugin-image"

export default function Home({ data }) {
  console.log(data)
  return (
    <Layout>
      <section className={styles.header}>
        <div>
          <h2>NFT Posts</h2>
          <h3>NFT Directory Listings</h3>
          <p>Markdown Content Driven Postings. Art of the NFT</p>
          <p>This is a Gatsby site built from a Net Ninja tutorial. Adapted
            it to Version 3 Gatsby that dropped since the tutorial, to include the
            new GatsbyImages and some different naming rules that clashed with the styling.
            Huge shout out to The Net Ninja for his awesome web dev tutorials!!</p>
          <Link className={styles.btn} to="/projects">New NFT Projects</Link>
        </div>
        <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} alt="banner" />
      </section>
    </Layout>
  )
}

export const query = graphql`
query Mepic {
  file(relativePath: { eq: "GleTRNGL6520.png" }) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
}
`

